module.exports = __webpack_public_path__ + "img/2.dd40fa01.jpg";